import { usePageType } from '@app/page';
import { useLocation } from '@app/router';

const useLinkState = () => {
  const pageType = usePageType();
  const location = useLocation();

  return {
    prevPath: location?.pathname,
    prevPageType: pageType,
  };
};

export default useLinkState;
